module.exports = __webpack_public_path__ + "img/exerciseList.001dc1a9.svg";